<script setup lang="ts" generic="T">
import type { ITimelineRailPosition } from '@/core/timeline/timeline.types';
import { getTimelineRailPosition } from '@/core/timeline/timeline.utils';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    getKey: (item: T, index: number) => number | string;
    isItemVisible?: (item: T) => boolean;
    items: readonly T[];
    showRail?: boolean;
  }>(),
  { isItemVisible: undefined, showRail: true },
);

defineSlots<{
  default(props: {
    index: number;
    item: T;
    itemCount: number;
    nextItem: T | undefined;
    previousItem: T | undefined;
    rail: Required<ITimelineRailPosition>;
  }): void;
}>();

const visibleItems = computed(() => {
  const isItemVisible = props.isItemVisible;
  return isItemVisible ? props.items.filter(isItemVisible) : props.items;
});
</script>

<template>
  <ul class="flex flex-col">
    <li v-for="(item, index) in visibleItems" :key="props.getKey(item, index)">
      <slot
        :index="index"
        :item="item"
        :item-count="visibleItems.length"
        :next-item="visibleItems[index + 1]"
        :previous-item="visibleItems[index - 1]"
        :rail="{ ...getTimelineRailPosition(index, visibleItems.length), showRail: props.showRail }"
      ></slot>
    </li>
  </ul>
</template>
